var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mostWatch-bar",attrs:{"id":"mostWatch_bar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }